import "@tamagui/polyfill-dev";
import { isServer } from "@tamagui/constants";
import { YStack } from "@tamagui/stacks";
import * as React from "react";
import { createPortal } from "react-dom";
import { useDidFinishSSR } from "@tamagui/use-did-finish-ssr";
import { jsx } from "react/jsx-runtime";
const Portal = React.memo(({
  host = globalThis.document?.body,
  ...props
}) => {
  if (isServer) return null;
  const didFinishSSR = useDidFinishSSR(),
    contents = /* @__PURE__ */jsx(YStack, {
      contain: "strict",
      fullscreen: !0,
      position: "fixed",
      maxWidth: "100vw",
      maxHeight: "100vh",
      pointerEvents: "none",
      ...props
    });
  return createPortal(didFinishSSR ? contents : null, host);
});
export { Portal };
//# sourceMappingURL=Portal.mjs.map
